import React from 'react';

import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Link from '@marvelapp/marvel-ui/link';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Align from '@marvelapp/marvel-ui/align';

import IntegrationsCta from 'marketing-website/components/modules/IntegrationsCta';
import Whitespace from 'marketing-website/components/commons/Whitespace';
import Image from 'marketing-website/components/modules/Image';
import Page from 'marketing-website/components/modules/Page';

import assets from 'marketing-website/configs/pages/apple-watch-prototyping/assets';

import Ideas from './ideas.js';
import Embed from './embed.js';
import Files from './files.js';

export default function AppleWatchPrototyping() {
  return (
    <Page
      title="Create free Apple Watch prototypes | Marvel"
      meta={[
        {
          name: 'description',
          content:
            'Prototype your sketches and design mockups for the Apple Watch with Marvel',
        },
        {
          name: 'keywords',
          content:
            'apple watch, prototyping, prototype, watchOS, watch prototyping',
        },
      ]}
      header
      footer
    >
      <PageWrap size="l">
        <Whitespace size="s" sizeS="l" sizeM="xl" />
        <Align type="center">
          <Spacing size="s" type="padding" position="bottom">
            <Image {...assets.watch} />
          </Spacing>
          <MaxWidth value={720}>
            <Heading tag="h1" weight="semibold" size="mega">
              View your sketches and design mockups on the Apple Watch
            </Heading>
          </MaxWidth>
          <Spacing size="s" type="padding" position="topBottom">
            <MaxWidth value={720}>
              <Paragraph size="xxxl" color="slate">
                Marvel is the easiest way to turn your sketches and mockups into
                prototypes and view them on the Apple Watch!
              </Paragraph>
            </MaxWidth>
          </Spacing>
          <Spacing size="s" type="padding" position="top">
            <Spacing size="l" type="padding" position="bottom">
              <Link
                url="https://itunes.apple.com/us/app/marvel-app/id765801658?mt=8"
                target="_blank"
              >
                <Image {...assets.appStore} />
              </Link>
            </Spacing>
          </Spacing>
          <Ideas />
          <Files />
          <Embed />
        </Align>
      </PageWrap>
      <IntegrationsCta />
    </Page>
  );
}



// WEBPACK FOOTER //
// ./src/pages/apple-watch-prototyping/index.js